module.exports = __webpack_public_path__ + "static/img/quanansu.77586a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/quanansu.jpg
// module id = OPG4
// module chunks = 0